import React from "react"
import { Footer } from "flowbite-react"

import { useFooterDetails } from "../../hooks/use-footer-details"
import logo from "../../images/logos/my_radar_logo_gray.png"
import BackgroundGlowFooter from "../../images/bg_glow_footer.png"
import BackgroundGlowFooterMobile from "../../images/bg_glow_footer_mobile.png"

const LinksColumn = ({ links }) => {
  return (
    <div className="">
      <Footer.Title title={links.filter((link) => link.heading)[0].text} />
      <Footer.LinkGroup col>
        {links
          .filter((link) => !link.heading)
          .map((link) => (
            <Footer.Link key={link.text} href={link.url}>
              {link.text}
            </Footer.Link>
          ))}
      </Footer.LinkGroup>
    </div>
  )
}

const CustomFooter = () => {
  const { tagline, social_media_links, links } = useFooterDetails()
  const socialMediaLinks = social_media_links.filter((link) => link.visible)
  const columnOneLinks = links.filter((link) => link.column === "1")
  const columnTwoLinks = links.filter((link) => link.column === "2")
  const columnThreeLinks = links.filter((link) => link.column === "3")

  return (
    <Footer container className="px-4 md:px-20 bg-brand-black">
      <div className="relative max-w-[1440px] py-10 md:py-20">
        <div className="absolute left-0 top-56 sm:top-44 md:top-0 sm:-left-8 md:left-auto sm:right-0 z-10">
          <img
            src={BackgroundGlowFooter}
            alt=""
            className="h-full hidden md:block"
          />
          <img
            src={BackgroundGlowFooterMobile}
            alt=""
            className="h-full md:hidden"
          />
        </div>
        <div className="relative z-20">
          <div className="gap-8 grid md:grid-cols-2 lg:grid-cols-4 full:grid-cols-footer">
            <div className="pr-10">
              <img src={logo} className="w-60 md:w-80" alt="MyRadar® Logo" />
              <p
                className="mt-5 md:mt-8 text-gray-400 leading-6"
                dangerouslySetInnerHTML={{ __html: tagline }}
              />
              <div className="mt-8 flex gap-4">
                {socialMediaLinks.map((link) => (
                  <a key={link.name} href={link.url}>
                    <img
                      src={link.icon}
                      alt={link.name}
                      className="w-4 h-4 md:w-6 md:h-6 lg:w-4 lg:h-4 xl:h-8 xl:w-8"
                    />
                  </a>
                ))}
              </div>
            </div>

            <LinksColumn links={columnOneLinks} />
            <LinksColumn links={columnTwoLinks} />
            <LinksColumn links={columnThreeLinks} />
          </div>

          <Footer.Divider />

          <Footer.Copyright
            href="https://acmeaom.com"
            by={`${new Date().getFullYear()} Acme AtronOMatic, LLC. All rights reserved!`}
          />
        </div>
      </div>
    </Footer>
  )
}

export default CustomFooter
